/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { GraphQLList as List } from 'graphql';
import fetch from '../../core/fetch';
import AgenceType from '../types/AgenceType';

const url = 'http://agenceprolifik.ca/dev/wp-json/wp/v2/pages/264/';

let item;

const agence = {
    type: AgenceType,
    resolve() {
        
        return fetch(url)
        .then(res => {
            
            return res.json();
           
        })
        .then(data => {
           
            item = data;
            return item;

        });
    },
};

export default agence;



// WEBPACK FOOTER //
// ./data/queries/agence.js